import type { EnrichedHerdRecord, OperationType } from "shared/types";
import {
  LIST_FARM_ENRICHED_HERD_RECORDS,
  LIST_OPERATION_TYPES,
  type MovementsDispatchAction,
} from "../actions/movementsActions";

export type MovementsState = {
  operationTypes: OperationType[];
  farmEnrichedHerdRecords: EnrichedHerdRecord[];
};

export const initialState: MovementsState = {
  operationTypes: [],
  farmEnrichedHerdRecords: [],
};

export default function movementsReducer(
  state: MovementsState = initialState,
  action: MovementsDispatchAction
): MovementsState {
  if (action.type === LIST_FARM_ENRICHED_HERD_RECORDS) {
    return {
      ...state,
      farmEnrichedHerdRecords: action.payload.records,
    };
  }

  if (action.type === LIST_OPERATION_TYPES) {
    return {
      ...state,
      operationTypes: action.payload.operationTypes,
    };
  }

  return { ...state };
}
